module.exports = __webpack_public_path__ + "static/mu-5e5acde4dfc59f506944b1c57014a60c.jpg";